import * as React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import {
  updateCurrentWorkout,
  UpdateCurrentWorkout
} from "../../resources/user/user.actions";
import { IExercise } from "../../resources/user/types";
import Button from "../../components/button/index";
import SelectLifts from "../../components/select-lifts";
import { exercisesConfig } from "../../constants/exercises";

import styles from "./create.module.css";

interface IProps {
  updateCurrentWorkout: UpdateCurrentWorkout;
}

function Create({ updateCurrentWorkout }: IProps) {
  const inputRef = React.useRef<any>();
  const [date, setDate] = React.useState<string>("");
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const [selectedLifts, setSelectedLifts] = React.useState<string[]>([]);

  const onChangeDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDate(e.target.value);
  };

  const handleSelectedLifts = (selected: string[]) =>
    setSelectedLifts(selected);

  const onSubmitExercise = () => {
    const exercises = selectedLifts.map(lift => {
      const exercise: any = exercisesConfig.find(config => config.id === lift);

      return {
        ...exercise,
        exerciseSets: [
          {
            id: uuidv4(),
            sets: 3,
            reps: 5,
            weight: 45,
            pos: 0
          }
        ]
      } as IExercise;
    });

    updateCurrentWorkout({
      date: moment(date, "YYYY-MM-DD").format(),
      exercises,
      timestamp: moment.utc(date, "YYYY-MM-DD").unix()
    });
    history.push(`/users/${id}/workout/edit`);
  };

  const onClick = () =>
    inputRef && inputRef.current && inputRef.current.focus();

  return (
    <>
      <div className={styles.workout}>Select a workout date</div>
      <div className={styles.create} onClick={onClick}>
        <div className={styles.date}>Date</div>
        <div className={styles.value}>
          {date
            ? moment(date, "YYYY-MM-DD").format("ddd, MMM D, YYYY")
            : "— Select Date —"}
        </div>
        <div className={styles.blockInput}>
          <input
            ref={inputRef}
            className={styles.input}
            type="date"
            value={date}
            onChange={onChangeDate}
          />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.workout}>Select your lifts.</div>
        <SelectLifts onChange={handleSelectedLifts} />
        <Button
          onClick={onSubmitExercise}
          disabled={!selectedLifts.length || !date}
        >
          Continue
        </Button>
      </div>
    </>
  );
}

export default connect(null, { updateCurrentWorkout })(Create);
